
import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faWallet } from '@fortawesome/free-solid-svg-icons';

function AddAccountForm({ onAccountAdded }) {
  const [name, setName] = useState('');
  const [currency, setCurrency] = useState('USD');
  const [type, setType] = useState('cash');
  const [holder, setHolder] = useState('Kateryna');
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const id = uuidv4();
    await axios.post(`${process.env.REACT_APP_API_URL}/accounts`, { id, name, currency, type, holder });
    onAccountAdded();
    setName('');
  };

  return (
    <form onSubmit={handleSubmit} className="card bg-white dark:bg-dark-surface p-6 mb-6 transition-colors">
      <h3 className="text-lg font-bold text-gray-800 dark:text-white mb-4 flex items-center gap-2">
        <FontAwesomeIcon icon={faWallet} className="text-primary-500" />
        {t('addAccount')}
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="md:col-span-2">
          <label htmlFor="accountName" className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
            {t('accountName')}
          </label>
          <input
            type="text"
            id="accountName"
            placeholder={t('enterAccountName')}
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white"
            required
          />
        </div>
        
        <div>
          <label htmlFor="currency" className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
            {t('currency')}
          </label>
          <select
            id="currency"
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white"
          >
            <option value="UAH">UAH</option>
            <option value="USD">USD</option>
            <option value="HUF">HUF</option>
            <option value="EUR">EUR</option>
          </select>
        </div>
        
        <div>
          <label htmlFor="type" className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
            {t('type')}
          </label>
          <select
            id="type"
            value={type}
            onChange={(e) => setType(e.target.value)}
            className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white"
          >
            <option value="cash">{t('cash')}</option>
            <option value="card">{t('card')}</option>
          </select>
        </div>
        
        <div className="md:col-span-2">
          <label htmlFor="holder" className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
            {t('holder')}
          </label>
          <select
            id="holder"
            value={holder}
            onChange={(e) => setHolder(e.target.value)}
            className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white"
          >
            <option value="Kateryna">{t('kateryna')}</option>
            <option value="Serhii">{t('serhii')}</option>
          </select>
        </div>
      </div>
      
      <button 
        type="submit" 
        className="btn-primary w-full py-3 rounded-xl flex items-center justify-center gap-2 font-bold"
      >
        <FontAwesomeIcon icon={faPlus} />
        {t('addAccount')}
      </button>
    </form>
  );
}

export default AddAccountForm;
